import AvatarManager from '@/helpers/avatarManager';

const faceSceneInitComponent = {
  schema: {
    uri: { type: 'string' },
  },
  init: function () {
    const scene = this.el.sceneEl.object3D;
    const uri = this.data.uri;
    if (!uri) return;
    let avatarManager = AvatarManager.getInstance();
    avatarManager.loadFace(uri).then(() => {
      const faceScene = avatarManager.getScene();
      scene.add(faceScene);
    });
  },
};

export { faceSceneInitComponent };
